import React, { useCallback, useEffect, useState } from "react";
import { buildApiUrl } from "../services/apiConfig.ts";
import { useAuth } from "../AuthProvider.tsx";
import PortalSidebar from "../components/PortalSidebar.tsx";
import "./overview.css";

export default function OrganizationSettings() {
  const { fetchWithAuth } = useAuth();
  const [data, setData] = useState<any>({ users: [], invitations: [] });
  const [organization, setOrganization] = useState<any>(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("org_member");
  const [message, setMessage] = useState("");

  const load = useCallback(async () => {
    const organizationResponse = await fetchWithAuth(buildApiUrl("/organization"));
    if (organizationResponse.ok) {
      const result = await organizationResponse.json();
      setOrganization(result.organization);
      setName(result.organization?.name || "");
    }
    const usersResponse = await fetchWithAuth(buildApiUrl("/organization/users"));
    if (usersResponse.ok) setData(await usersResponse.json());
  }, [fetchWithAuth]);

  useEffect(() => { load(); }, [load]);

  const saveName = async (event: React.FormEvent) => {
    event.preventDefault();
    const response = await fetchWithAuth(buildApiUrl("/organization"), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    });
    if (!response.ok) return setMessage(await response.text());
    const result = await response.json();
    setOrganization(result.organization);
    setName(result.organization.name);
    setMessage("Organisationsname gespeichert.");
  };

  const invite = async (event: React.FormEvent) => {
    event.preventDefault();
    setMessage("");
    const response = await fetchWithAuth(buildApiUrl("/organization/invitations"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, role }),
    });
    if (!response.ok) return setMessage(await response.text());
    setEmail("");
    setMessage("Einladung wurde per E-Mail versendet.");
    await load();
  };

  const remove = async (id: string) => {
    if (!window.confirm("Mitglied entfernen?")) return;
    await fetchWithAuth(buildApiUrl(`/organization/users/${encodeURIComponent(id)}`), { method: "DELETE" });
    await load();
  };

  return <div className="portal-root"><PortalSidebar /><main className="portal-main">
    <div className="portal-topbar"><div className="portal-title">{organization?.name || "Organisation"}</div></div>
    <section className="portal-panel">
      {message && <div className="portal-banner info">{message}</div>}
      <h3>Organisationsname</h3>
      <form className="organization-form" onSubmit={saveName}>
        <input required maxLength={256} value={name} onChange={event => setName(event.target.value)} />
        <button className="btn dark">Speichern</button>
      </form>
      <h3>Mitglied einladen</h3>
      <form className="organization-form" onSubmit={invite}>
        <input required type="email" placeholder="E-Mail" value={email} onChange={event => setEmail(event.target.value)} />
        <select value={role} onChange={event => setRole(event.target.value)}><option value="org_member">Mitglied</option><option value="org_admin">Admin</option></select>
        <button className="btn dark">Einladen</button>
      </form>
      <h3>Mitglieder</h3>
      {data.users.map((user: any) => <div key={user.user_id} className="portal-mobile-field organization-member-row"><span>{user.email || "E-Mail noch nicht verfügbar"} — {user.role}</span><button className="btn warn" onClick={() => remove(user.user_id)}>Entfernen</button></div>)}
      <h3>Offene Einladungen</h3>
      {data.invitations.map((invitation: any) => <div key={invitation.id}>{invitation.email} — {invitation.role}</div>)}
    </section>
  </main></div>;
}
